"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/controls/TextInput/TextInput");
const utils_1 = require("../../../helpers/utils");
const layout_1 = require("../layout");
require("../types");
function TextField(_a) {
    var _b, _c, _d, _e;
    var { field: { input, meta }, label, inlineLabel, helpText, suffix, errorView, extendError, withCopy, copyButtonIcon, copyButtonLabel, onChange, preventedInputChangeValue = false } = _a, otherProps = __rest(_a, ["field", "label", "inlineLabel", "helpText", "suffix", "errorView", "extendError", "withCopy", "copyButtonIcon", "copyButtonLabel", "onChange", "preventedInputChangeValue"]);
    const touched = (_b = meta === null || meta === void 0 ? void 0 : meta.touched) !== null && _b !== void 0 ? _b : false;
    const modified = (_c = meta === null || meta === void 0 ? void 0 : meta.modified) !== null && _c !== void 0 ? _c : false;
    const error = (_d = ((meta === null || meta === void 0 ? void 0 : meta.error) || extendError)) !== null && _d !== void 0 ? _d : '';
    const submitError = (_e = meta === null || meta === void 0 ? void 0 : meta.submitError) !== null && _e !== void 0 ? _e : '';
    const errorMessage = ((touched || modified) && error) || submitError || '';
    const handleCopyToClipboard = react_1.useCallback(() => {
        utils_1.copyToClipboard(input === null || input === void 0 ? void 0 : input.value);
    }, [input === null || input === void 0 ? void 0 : input.value]);
    return (react_1.default.createElement(layout_1.FieldLayout, { label: label, inlineLabel: inlineLabel, disabled: otherProps.disabled, helpText: helpText, suffix: withCopy ? (react_1.default.createElement(components_1.StackView, { indentLeft: components_1.VIEW_INDENT.s, gap: components_1.STACK_GAP.s },
            react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.text, disabled: otherProps.disabled, onClick: () => {
                    handleCopyToClipboard();
                } },
                copyButtonIcon && react_1.default.createElement(components_1.Icon, { src: copyButtonIcon, disabled: otherProps.disabled }),
                copyButtonLabel),
            suffix)) : (suffix), widthSize: otherProps.size === components_1.CONTROL_SIZE.full ? components_1.CONTROL_SIZE.full : undefined, error: errorMessage, errorView: errorView },
        react_1.default.createElement(components_1.TextInput, Object.assign({}, otherProps, { value: input.value, error: !!errorMessage, onBlur: (e) => {
                var _a;
                const { value } = input;
                const trimmedValue = (_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : '';
                if (value !== trimmedValue) {
                    if (!preventedInputChangeValue) {
                        input.onChange(Object.assign(Object.assign({}, e), { target: Object.assign(Object.assign({}, e.target), { value: trimmedValue }) }));
                    }
                    onChange === null || onChange === void 0 ? void 0 : onChange(trimmedValue);
                }
                if (!preventedInputChangeValue) {
                    input.onBlur(e);
                }
            }, onFocus: (e) => {
                if (!preventedInputChangeValue) {
                    input.onFocus(e);
                }
            }, onChange: (value) => {
                if (!preventedInputChangeValue) {
                    input.onChange(value);
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            } }))));
}
exports.TextField = TextField;
TextField.displayName = 'TextField';
//# sourceMappingURL=TextField.js.map